import React from 'react';

const StatusIndicator = ({ value, customData = false }) => {
  const getButtonValue = statusId => {
    if (statusId === 1) {
      return <span>Adding Info</span>;
    } else if (statusId === 2) {
      return <span>Waiting For Setup</span>;
    } else if (statusId === 3) {
      return <span>Need More Information</span>;
    } else if (statusId === 4) {
      return <span>Pending Addition To Website</span>;
    } else if (statusId === 5) {
      return <span>Completed</span>;
    }
  };
  const getClass = statusCode => {
    if (statusCode === 1) {
      return 'text-primary';
    } else if (statusCode === 2) {
      return 'text-warning';
    } else if (statusCode === 3) {
      return 'text-danger';
    } else if (statusCode === 4) {
      return 'text-darkgray';
    } else if (statusCode === 5) {
      return 'text-success';
    }
  };

  return (
    <span className={customData ? value?.color : getClass(value)}>
      {customData ? value?.label : getButtonValue(value)}
    </span>
  );
};

export default StatusIndicator;

 
export const StatusIndicatorChip = ({ value, customData = false }) => {
  const getButtonValue = statusId => {
    switch (statusId) {
      case 1:
        return 'In Progress';
      case 2:
        return 'Completed';
      case 3:
        return 'Caller To Business In Transit';
      case 4:
        return 'Business Handling';
      default:
        return 'Unknown';
    }
  };
  const getCss = statusId => {
    switch (statusId) {
      case 1:
        return { color: '#3354F4', bgColor: '#DEE2F5' };
      case 2:
        return { color: '#0F6202', bgColor: '#E1F5DE' };
      case 3:
      case 4:
        return { color: 'var(--warning)', bgColor: 'var(--warning-4)' };
      default:
        return { color: '#000', bgColor: '#eee' };
    }
  };
  const styles = customData ? {} : getCss(value.value);
  const label = customData ? value?.name : getButtonValue(value.value);
  return (
    <span
      className={customData ? value?.color : getCss(value)}
      style={{
        padding: '4px 14px',
        borderRadius: '50px',
        fontSize: '13px',
        lineHeight: 1,
        backgroundColor: styles.bgColor,
        color: styles.color
      }}
    >
      {label}
    </span>
  );
};